
export function makeUpdateUIDsListActionCreator(type, ...argNames) {
    /*
        Create an update UID list action

        {
            type,
            uidList,
            replaceAll
        }
     */
    return function(...args) {
        const action = { type };
        argNames.forEach((arg, index) => {
            action[argNames[index]] = args[index]
        });
        return action
    }
}

export function makeUpdateDictActionCreator(type, ...argNames) {
    /*
        Create an update dict in state action
     */
    return function(...args) {
        const action = { type };
        argNames.forEach((arg, index) => {
            action[argNames[index]] = args[index]
        });

        return action
    }
}